import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { EnvironmentService } from '@irian-ro/util-environment';
import { IpEnvironment } from '@ipensii/shared/domain-shared';
import { AuthService } from '../auth.service';

export const authHeaderInterceptor: HttpInterceptorFn = (req, next) => {
  const env: EnvironmentService<IpEnvironment> = inject(EnvironmentService);
  const authService = inject(AuthService);
  const authToken = authService.authToken;
  const shouldAuthorize =
    authToken != null &&
    !env.getEnvironment().publicRequests.some((r) => (!r.method || req.method === r.method) && req.url.includes(r.url));

  if (shouldAuthorize) {
    const authReq = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${authToken}`),
    });
    return next(authReq);
  }
  return next(req);
};
